import styled from "styled-components";

import ArrowDownIconDisabled from "./icons/ArrowDown/icon-disabled.svg";
import ArrowDownIcon from "./icons/ArrowDown/icon.svg";
import { inputCss } from "./styles";

export const Select = styled.select`
  ${inputCss}
  width: 100%;
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
  -webkit-appearance: none;
  -moz-appearance: none;

  /* The url must be quoted: Vite inlines small SVGs as data URIs containing quotes */
  padding-right: 2.75rem;
  background: url("${ArrowDownIcon}") no-repeat right 1rem center transparent;
  background-size: 12px auto;

  /* Clearly unavailable: faded, no fill */
  &:disabled {
    cursor: not-allowed;
    background: url("${ArrowDownIconDisabled}") no-repeat right 1rem center transparent;
    background-size: 12px auto;
    opacity: 0.3;
  }

  > option {
    background-color: var(--color-neutral-darkness);
    color: var(--color-neutral-white);
    padding: 0.5rem 1rem;
    outline: none;

    &:checked {
      background-color: var(--color-neutral-light);
    }
    &:not(:checked) {
      background-color: var(--color-neutral-darkness);
    }
  }
`;
